///
/// Copyright (c) 2017-present, Siklu Ltd.
/// All rights reserved.
///

export class GtthPreloaderModalEvent {
    static showDefault(): GtthPreloaderModalEvent {
        return new GtthPreloaderModalEvent(true, undefined);
    }

    static show(title: string): GtthPreloaderModalEvent {
        return new GtthPreloaderModalEvent(true, title);
    }

    static hide(): GtthPreloaderModalEvent {
        return new GtthPreloaderModalEvent(false, undefined);
    }

    constructor(
        public isShow = false,
        public title: string
    ) {}
}
